import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {PortfolioPhoto} from '../../../core/entities/portfolio/portfolio-photo.entity';
import {environment} from '../../../../environments/environment';
import {Photo} from '../../../core/entities/photo/photo.entity';

@Injectable({
  providedIn: 'root'
})
export class PortfolioService {
  public constructor(
    private readonly http: HttpClient,
  ) {
  }

  public getPortfolio(): Observable<PortfolioPhoto[]> {
    return this.http.get<PortfolioPhoto[]>(`${environment.apiUrl}/manage/portfolio`);
  }

  public addPortfolioPhotos(photos: File[]): Observable<PortfolioPhoto[]> {
    const formData = new FormData();

    if (photos) {
      photos.forEach(f => formData.append('photos[]', f, f.name));
    }

    return this.http.post<PortfolioPhoto[]>(`${environment.apiUrl}/manage/portfolio`, formData).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Portfolio Photo upload failed', error);
        return throwError(() => error);
      })
    );
  }

  public deletePhoto(
    id: number
  ): Observable<null> {
    return this.http.delete<null>(`${environment.apiUrl}/manage/portfolio/${id}`).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Portfolio Photo delete failed', error);
        return throwError(() => error);
      })
    );
  }

  /**
   * @param orderedPhotos { id, position } photo id and photo position
   */
  public updateOrder(orderedPhotos: { id: number; position: number }[]): Observable<{ success: boolean }> {
    return this.http.put<{ success: boolean }>(`${environment.apiUrl}/manage/portfolio/order`, orderedPhotos);
  }
 }
